import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { zip } from 'lodash';
import Fetchable from '~/commons/components/util/Fetchable';
import Page from '../layout/Page';
import Html from '../../../commons/components/util/Html';
import Card from '../layout/Card';

const PageTopics = () => {
  const { topic } = useParams();
  const { i18n, t } = useTranslation();
  const [width, setWidth] = useState();
  const isMobile = width <= 768;
  const navigate = useNavigate();

  useEffect(() => {
    setWidth(window.innerWidth);
    const callback = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', callback);

    return () => window.removeEventListener('resize', callback);
  }, []);
  return (
    <Page card={null}>
      <Fetchable req={{ url: '/api/topics' }}>
        {({ rows: topics }) => {
          const current = topics.find((e) => e.url === `/${topic}`);
          const defaultTopic = topics.find((e) => e.url === '/');
          return (
            <div className="container">
              <div className="row justify-content-around">
                <div className="col-9 col-md-5 col-lg-4">
                  <h4 className="fw-bold mb-5" style={{ textAlign: 'center' }}>
                    {t('pg.topics')}
                  </h4>
                  <div className="position-relative">
                    <img
                      className="position-relative w-100"
                      src="/assets/img/cabinet-body.png"
                      alt=""
                    />
                    <img
                      className="position-absolute w-100"
                      src="/assets/img/cabinet-body-top.png"
                      alt=""
                      style={{
                        top: '0',
                        left: '0',
                        zIndex: 200,
                      }}
                    />
                    {zip(
                      Array(24).fill({}),
                      topics.filter((e) => e.url !== '/'),
                    ).map(([, e = {}], i) => {
                      const mappingArray = [
                        'left',
                        'leftMiddle',
                        'rightMiddle',
                        'right',
                      ];
                      const col = i % 4;
                      const row = Math.floor(i / 4);
                      const dir = col < 2 ? 'left' : 'right';
                      const pos = mappingArray[col];
                      const top = 19 + row * 11;
                      const dirPos = 6.5 + (col === 1 || col === 2 ? 21.55 : 0);
                      const active = '_id' in e && current?._id === e._id;
                      let to = e.url ? `/topics${e.url}` : '#';

                      if (active) to = '/topics';
                      return (
                        <Link key={e._id} to={to}>
                          <img
                            key={e._id}
                            src={`/assets/img/cabinet-drawer-${pos}-open.png`}
                            alt=""
                            className={
                              active
                                ? 'position-absolute active cabinet'
                                : 'position-absolute cabinet'
                            }
                            style={{
                              width: active ? '21.95%' : '21.95%',
                              [dir]: `${dirPos}%`,
                              top: `${top}%`,
                              zIndex: 100 - i,

                            }}
                          />
                        </Link>
                      );
                    })}
                  </div>
                </div>
                {isMobile && (
                  <div>
                    <h4 className="fw-bold font-capitalize text-center">
                      {t('pg.chooseTopics')}
                    </h4>
                    <div>
                      <select
                        id="topicSelect"
                        className="form-select text-center customDropdown"
                        value={current?.url || '/'}
                        onChange={(evt) => navigate(`/topics${evt.target.value}`)}
                      >
                        {topics.map((l, i) => (
                          <option
                            key={i}
                            value={l.url}
                          >
                            {i18n.pickLng(l.title) || l}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
                {defaultTopic && !current && (
                  <div className="col-10 col-md-5 col-lg-6 mt-4">
                    <Card>
                      <div>
                        {!isMobile
                        && (
                        <h4 className="fw-bold font-capitalize">
                          {i18n.pickLng(defaultTopic.title)}
                        </h4>
                        )}
                        <div
                          style={{
                            height: isMobile ? '100%' : '25vw',
                            overflowY: 'auto',
                            width: '100%',
                          }}
                        >
                          <Html>{i18n.pickLng(defaultTopic.description)}</Html>
                        </div>
                      </div>
                    </Card>
                  </div>
                )}
                {current && (
                  <div className="col-12 col-md-5 col-lg-6 mt-4">
                    <Card>
                      <div>
                        {!isMobile && (
                          <h4 className="fw-bold font-capitalize">
                            {i18n.pickLng(current.title)}
                          </h4>
                        )}
                        <div
                          style={{
                            height: isMobile ? '100%' : '25vw',
                            overflowY: 'auto',
                            width: '100%',
                          }}
                        >
                          <Html>{i18n.pickLng(current.description)}</Html>
                        </div>
                      </div>
                    </Card>
                  </div>
                )}
              </div>
            </div>
          );
        }}
      </Fetchable>
    </Page>
  );
};

export default PageTopics;
